window.ExpandContent = (function($) {
  var obj = {};
  var local = {};

  var registeredTriggers = [];

  obj.expandContentHandler = function() {
    local.expandContentHandler();
  };

  var animationLock = false;

  var expandContentHandler = local.expandContentHandler = function() {
    $('[data-behavior=expand-content]').existsEach(function ($trigger) {
      if (registeredTriggers.indexOf($trigger) === -1) {
        $trigger.on('click', function(event) {
          event.preventDefault();
          var dataAttr = $trigger.data('expand-content');
          var container = $(dataAttr.container);
          var trackingConfig = $trigger.data('tracking');
          if (!animationLock) {
            animationLock = true;
            container.animate({
              height: 'toggle'
            } , {
              duration: 400,
              specialEasing: { height: 'easeInOutExpo' },
              complete: function() {
                var isVisible = container.is(':visible');
                var title = (isVisible && !!dataAttr.read_less) ? dataAttr.read_less : dataAttr.read_more;

                if (title) $trigger.text(title);

                if (isVisible) {
                  $trigger.addClass('content-expanded');
                  if (trackingConfig) {
                    ga('send', 'event', trackingConfig, 'open', '', { page: location.pathname });
                  }
                } else {
                  $trigger.removeClass('content-expanded');
                }

                ContactFormHelper.registerContactFormHandler(function() {
                  var mailSentContainer = $('.mail-sent');
                  mailSentContainer.fadeIn("slow", function() {
                    mailSentContainer.find('.gridder-close-btn').on('click', function() {
                      container.animate({
                        height: 'hide'
                      } , {
                        duration: 400,
                        specialEasing: { height: 'easeInOutExpo' }
                      });
                      return false;
                    });
                  });
                });
                selectize_all_selects();
                animationLock = false;
              }
            });
          }
        });
        registeredTriggers.push($trigger);
      }
    });
  }
  return obj;
})($);